module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-upload', {
    ref: "upload",
    attrs: {
      "list-type": "picture-card",
      "accept": "image/*",
      "limit": _vm.limit,
      "on-exceed": _vm.handleExceed,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList
    },
    scopedSlots: _vm._u([{
      key: "file",
      fn: function(ref) {
        var file = ref.file;

        return _c('div', {
          staticClass: "demo1-1"
        }, [_c('img', {
          staticClass: "imgs",
          attrs: {
            "src": file.url,
            "alt": ""
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "el-upload-list__item-actions"
        }, [_c('span', {
          staticClass: "el-upload-list__item-preview",
          on: {
            "click": function($event) {
              _vm.handlePictureCardPreview(file)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-zoom-in"
        })]), _vm._v(" "), (!_vm.disabled) ? _c('span', {
          staticClass: "el-upload-list__item-delete",
          on: {
            "click": function($event) {
              _vm.handleRemove(file)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })]) : _vm._e()])])
      }
    }])
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_c('span', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传 jpg/jpeg/png 文件，且不超过 2M " + _vm._s(_vm.tips))])], 1), _vm._v(" "), (_vm.showViewer) ? _c('el-image-viewer', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "on-close": _vm.closeViewer,
      "url-list": [_vm.imageUrl]
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-e99bc90a"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/inCComps/imgsUpload.vue
// module id = 1584
// module chunks = 1